/**
 * 时间格式化工具方法
 */

/**
 * 将秒转换为最合适的时间单位显示
 * @param {Number} seconds - 秒数
 * @param {Number} decimals - 小数位数，默认为1
 * @returns {String} 格式化后的时间字符串
 */
export function formatSeconds(seconds, decimals = 1) {
    if (!seconds || seconds < 0) return '0秒';

    const num = Number(seconds);

    // 小于1分钟，显示秒
    if (num < 60) {
        return `${Math.round(num)}秒`;
    }

    // 小于1小时，显示分钟
    if (num < 3600) {
        const minutes = num / 60;
        return `${minutes.toFixed(decimals)}分钟`;
    }

    // 大于等于1小时，显示小时
    const hours = num / 3600;
    return `${hours.toFixed(decimals)}小时`;
}

/**
 * 将秒转换为分钟
 * @param {Number} seconds - 秒数
 * @param {Number} decimals - 小数位数，默认为1
 * @returns {Number} 分钟数
 */
export function secondsToMinutes(seconds, decimals = 1) {
    if (!seconds || seconds < 0) return 0;
    const minutes = Number(seconds) / 60;
    return Number(minutes.toFixed(decimals));
}

/**
 * 将秒转换为小时（四舍五入）
 * @param {Number} seconds - 秒数
 * @param {Number} decimals - 小数位数，默认为1
 * @returns {Number} 小时数
 */
export function secondsToHours(seconds, decimals = 1) {
    if (!seconds || seconds < 0) return 0;
    const hours = Number(seconds) / 3600;
    const multiplier = Math.pow(10, decimals);
    return Math.round(hours * multiplier) / multiplier;
}

/**
 * 将秒转换为 时:分:秒 格式
 * @param {Number} seconds - 秒数
 * @returns {String} HH:MM:SS 格式的字符串
 */
export function secondsToHMS(seconds) {
    if (!seconds || seconds < 0) return '00:00:00';

    const num = Number(seconds);
    const hours = Math.floor(num / 3600);
    const minutes = Math.floor((num % 3600) / 60);
    const secs = Math.floor(num % 60);

    return [hours, minutes, secs]
        .map(val => String(val).padStart(2, '0'))
        .join(':');
}

/**
 * 将秒转换为中文时间描述
 * @param {Number} seconds - 秒数
 * @returns {String} 如：2小时30分钟15秒
 */
export function secondsToChinese(seconds) {
    if (!seconds || seconds < 0) return '0秒';

    const num = Number(seconds);
    const hours = Math.floor(num / 3600);
    const minutes = Math.floor((num % 3600) / 60);
    const secs = Math.floor(num % 60);

    let result = '';
    if (hours > 0) result += `${hours}小时`;
    if (minutes > 0) result += `${minutes}分钟`;
    if (secs > 0 || result === '') result += `${secs}秒`;

    return result;
}
